
import { Options, Vue } from 'vue-class-component';
import { mapState, mapMutations, mapActions } from 'vuex';
// Types
import { Alternative, Quiz } from '@/types/quiz.d';

@Options({
  computed: mapState(['answearsQuiz', 'currentQuiz', 'resultQuiz']),
  methods: {
    ...mapMutations(['RESET_ANSWEAR_QUIZ']),
    ...mapActions(['getAllQuizzesResponses', 'getQuizResponse']),
  },
})
export default class Result extends Vue {
  answearsQuiz!: Alternative[];

  currentQuiz!: Quiz;

  RESET_ANSWEAR_QUIZ!: (payload: Alternative[]) => void;

  getAllQuizzesResponses!: () => Promise<void>;

  getQuizResponse!: (idQuiz: string) => Promise<void>;

  closeAll(): void {
    console.log('QUIZ -> ', this.currentQuiz);
    console.log('ANSWERS -> ', this.answearsQuiz);
    this.RESET_ANSWEAR_QUIZ([]);
    this.$router.push('/');
  }

  goReview(): void {
    this.$router.push('/review');
  }

  async mounted(): Promise<void> {
    await this.getAllQuizzesResponses();
    await this.getQuizResponse(this.currentQuiz.id);
  }
}
